import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-404',
    templateUrl: 'not-found.component.html',
    styleUrls: ['not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {
    private router = inject(Router);


    goToLogin() {
        this.router.navigate(['login']);
    }
}
